import toast from 'react-hot-toast';
import { colors } from '../../../tailwind/colors.js';

const baseStyle = {
  background: colors.white,
  borderRadius: '8px',
  fontFamily: 'DM Sans, sans-serif',
  fontSize: '0.9rem',
  padding: '12px 16px',
  boxShadow: '0 4px 16px rgba(0,0,0,.10), 0 2px 6px rgba(0,0,0,.06)',
};

export function toastSuccess(message: string) {
  toast.success(message, {
    style: {
      ...baseStyle,
      color: colors.green[900],
      border: `1px solid ${colors.green[200]}`,
    },
    iconTheme: { primary: colors.green[900], secondary: colors.white },
    duration: 3000,
  });
}

export function toastError(message: string) {
  toast.error(message, {
    style: {
      ...baseStyle,
      color: colors.red[600],
      border: `1px solid ${colors.red[200]}`,
    },
    iconTheme: { primary: colors.red[600], secondary: colors.white },
    duration: 4000,
  });
}
